(() => {
  const root = document.getElementById('FuntoArtworkPopup');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const content = root.querySelector('.funto-artwork-popup__content');
  let opener;
  let spawned = [];
  let previousOverflow;
  let sizeObserver;
  let resizeFrame;
  const fitArtwork = () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      if (root.hidden) return;
      const panel = root.querySelector('.funto-artwork-popup__panel');
      const layout = root.querySelector('.funto-artwork-popup__layout');
      if (!layout) return;
      if (innerWidth < 750) {
        ['--popup-art-width','--popup-art-height','--popup-panel-width'].forEach(key => panel.style.removeProperty(key));
        return;
      }
      const side = layout.querySelector('.funto-artwork-popup__side');
      const products = layout.querySelector('.funto-artwork-popup__products');
      const label = layout.querySelector('.funto-artwork-popup__label');
      const frame = layout.querySelector('.funto-artwork-popup__frame');
      const style = getComputedStyle(frame);
      const ratio = parseFloat(getComputedStyle(layout).getPropertyValue('--art-ratio')) || 1;
      const edge = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
      const sideWidth = side.getBoundingClientRect().width;
      const naturalHeight = products.getBoundingClientRect().height + label.getBoundingClientRect().height + 16;
      const availableWidth = Math.min(1440,innerWidth - 48) - sideWidth - 24 - 32;
      const height = Math.max(edge + 1,Math.min(naturalHeight,innerHeight - 112,(availableWidth - edge) / ratio + edge));
      const width = (height - edge) * ratio + edge;
      panel.style.setProperty('--popup-art-width',width + 'px');
      panel.style.setProperty('--popup-art-height',height + 'px');
      panel.style.setProperty('--popup-panel-width',(width + sideWidth + 24 + 32) + 'px');
    });
  };
  window.addEventListener('resize',fitArtwork);
  const higherOpen = () => document.querySelector('quick-add-modal[open], cart-drawer.active, cart-notification.active');
  const close = () => {
    if (root.hidden) return;
    root.hidden = true;
    sizeObserver?.disconnect();
    cancelAnimationFrame(resizeFrame);
    document.body.classList.remove('funto-artwork-is-open');
    document.body.style.overflow = previousOverflow || '';
    spawned.forEach(node => node.remove());
    spawned = [];
    content.replaceChildren();
    opener?.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-artwork-popup]');
    if (!trigger) return;
    const source = document.getElementById(trigger.dataset.artworkPopup);
    if (!source) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!root.hidden) close();
    opener = trigger;
    const fragment = source.content.cloneNode(true);
    const ids = new Map();
    fragment.querySelectorAll('[id]').forEach(node => {
      if (node.id === 'FuntoArtworkTitle') return;
      const old = node.id;
      node.id = old + '-' + source.id;
      ids.set(old,node.id);
    });
    fragment.querySelectorAll('*').forEach(node => {
      ['for','form','aria-labelledby','aria-describedby','data-modal'].forEach(attr => {
        const value = node.getAttribute(attr);
        if (!value) return;
        node.setAttribute(attr,value.split(' ').map(part => part[0] === '#' ? '#' + (ids.get(part.slice(1)) || part.slice(1)) : ids.get(part) || part).join(' '));
      });
    });
    spawned = [...fragment.querySelectorAll('quick-add-modal')];
    content.replaceChildren(fragment);
    previousOverflow = document.body.style.overflow;
    root.hidden = false;
    document.body.classList.add('funto-artwork-is-open');
    root.querySelector('.funto-artwork-popup__panel').scrollTop = 0;
    sizeObserver = new ResizeObserver(fitArtwork);
    content.querySelectorAll('.funto-artwork-popup__products,.funto-artwork-popup__label').forEach(node => sizeObserver.observe(node));
    content.querySelectorAll('img').forEach(image => image.addEventListener('load',fitArtwork,{once:true}));
    document.fonts?.ready.then(fitArtwork);
    fitArtwork();
    root.querySelector('.funto-artwork-popup__close').focus({preventScroll:true});
  },true);
  root.addEventListener('click',event => {
    if (event.target === root || event.target.closest('.funto-artwork-popup__close')) close();
  });
  document.addEventListener('keydown',event => {
    if (root.hidden || higherOpen()) return;
    if (event.key === 'Escape') {event.preventDefault();close();return;}
    if (event.key !== 'Tab') return;
    const targets = [...root.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
    const first = targets[0], last = targets.at(-1);
    if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {event.preventDefault();last?.focus();}
    else if (!event.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) {event.preventDefault();first?.focus();}
  });
  document.body.addEventListener('modalClosed',() => {
    if (!root.hidden) document.body.classList.add('funto-artwork-is-open');
  });
  document.addEventListener('shopify:section:unload',close);
  document.addEventListener('shopify:block:select',event => {
    const trigger = event.target.querySelector('[data-artwork-popup]');
    if (trigger) trigger.click();
  });
})();
